import React, { useEffect, useState } from "react";
import { useShipOrder } from "../../api/orders/orders";

const CourierModal = ({
  order,
  courierOptions = [],
  loading = false,
  onClose,
  onShipped, // ✅ Add this callback
}) => {
  const {
    mutate: shipOrder,
    isLoading: isShipping,
    isSuccess,
  } = useShipOrder();

  const [selectedCourierId, setSelectedCourierId] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      onClose();
      setSelectedCourierId(null);
      onShipped?.(); // ✅ Call the callback to refresh orders
    }
  }, [isSuccess, onClose, onShipped]);

  const handleShip = (courier) => {
    const payload = {
      orderId: order?.shipcluesId, // ✅ Use shipcluesId from order
      partnerId: courier?.partner_id,
    };
    setSelectedCourierId(courier?.partner_id);

    shipOrder(payload, {
      onSettled: () => setSelectedCourierId(null),
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="relative w-full max-w-xl">
        <div className="bg-white rounded-lg shadow-xl p-6 relative z-10 max-h-[85vh] flex flex-col">
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-gray-500 hover:text-gray-800 text-2xl"
          >
            &times;
          </button>

          <h2 className="text-xl font-bold mb-6">Select Courier Partner</h2>

          {loading ? (
            <p className="text-gray-500 text-center py-6">
              Fetching courier rates...
            </p>
          ) : courierOptions?.length > 0 ? (
            <>
              <div className="grid grid-cols-3 font-semibold text-gray-600 text-sm border-b pb-2 mb-3 px-2">
                <div>Courier Partner</div>
                <div className="text-center mr-6">EDD</div>
                <div className="text-right mr-7">Total Price</div>
              </div>

              <div className="overflow-y-auto flex-1 pr-1 space-y-3">
                {courierOptions.map((courier, index) => {
                  const isButtonLoading =
                    isShipping && selectedCourierId === courier?.partner_id;

                  return (
                    <div
                      key={index}
                      className="grid grid-cols-3 items-center p-4 border rounded-lg shadow-sm hover:shadow-md transition"
                    >
                      <div className="flex items-center gap-4">
                        <img
                          src={courier.courierLogo}
                          alt={courier.courierTitle}
                          className="w-10 h-10 object-contain"
                        />
                        <p className="font-medium">{courier.courierTitle}</p>
                      </div>

                      <div className="text-center text-gray-700 font-medium">
                        {courier.edd_date}
                      </div>

                      <div className="flex flex-col items-end">
                        <div className="text-lg font-bold text-black">
                          ₹{courier.rateWithGST}
                        </div>
                        <button
                          disabled={isShipping}
                          className="mt-2 bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center"
                          onClick={() => handleShip(courier)}
                        >
                          {isButtonLoading ? (
                            <>
                              <svg
                                className="w-5 h-5 animate-spin text-white mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8H4z"
                                />
                              </svg>
                              Shipping...
                            </>
                          ) : (
                            "Ship"
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <p className="text-gray-500 text-center py-6">
              No courier partners available.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourierModal;